module.exports = __webpack_public_path__ + "static/media/bg-5-features.f0da7d6e.svg";